import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { ENV } from '@app/env';

@Injectable()
export class LinkPagamentiProvider {

	url = ENV.wp_domain+'/_/get-link-pagamento.php';

	constructor(public http: Http) {}

	getLink( amount: Number, tipo: string ): Promise<any> {
		return new Promise((resolve, reject) => {
			const params = {
				tipo  : tipo,
				amount: amount
			};
			const json = JSON.stringify(params);
			const headers = new Headers({
				'Content-Type': 'application/json',
				// 'Content-Type': 'application/x-www-form-urlencoded',
			});
			const options = new RequestOptions({ headers: headers });
			this.http.post(this.url, json, options )
				.map(res => res.text())
				.timeout(10000)
				.subscribe(link => {
					if( link ) {
						resolve(link);
					}
				});
		});
	}

}



// WEBPACK FOOTER //
// ./src/providers/link-pagamenti/link-pagamenti.ts